import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./HomeServices.css"; // Custom CSS
import config from "../config";
import localCategories from "../data/categories.json"; // fallback JSON

const serviceIcons = {
  "Audit & Assurance": "bi bi-check2-square",
  "Income Tax Services": "bi bi-cash-stack",
  "GST Services": "bi bi-receipt",
  "TDS/TCS & Compliance Services": "bi bi-file-earmark-text",
  "Financial & Tax Advisory": "bi bi-graph-up",
  "Business Setup & Registration": "bi bi-building",
  "Accounting & Bookkeeping": "bi bi-journal-check",
};

const HomeServices = () => {
  const [services, setServices] = useState([]);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await axios.get(`${config.apiBaseURL}/Categories/GetHierchy`);
        if (res?.data && Array.isArray(res.data)) {
          setServices(res.data.filter((s) => s.statusId === 1));
        } else {
          console.warn("Invalid API data, using local JSON fallback");
          setServices(localCategories.filter((s) => s.statusId === 1));
        }
      } catch (err) {
        console.error("API error, using local JSON fallback:", err);
        setServices(localCategories.filter((s) => s.statusId === 1));
      }
    };
    fetchServices();
  }, []);

  // Recursive children renderer filtering active only
  const renderChildren = (children) => {
    if (!children || children.length === 0) return null;

    return (
      <ul className="sub-services">
        {children
          .filter((child) => child.statusId === 1)
          .map((child) => (
            <li key={child.categoryId}>
              {child.categoryName}
              {renderChildren(child.children)}
            </li>
          ))}
      </ul>
    );
  };

  return (
    <section id="services" className="services section">
      <div className="container">
        <div className="section-title" data-aos="fade-up">
          <h2>Our Services</h2>
          <p>
            We offer a wide range of services to meet the diverse needs of our
            clients. Our team of experts provides personalized solutions that
            drive success and growth.
          </p>
        </div>

        <div className="row gy-4">
          {services.map((service, index) => (
            <div
              className="col-lg-4 col-md-6"
              key={service.categoryId}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="service-card position-relative">
                <div className="icon">
                  <i
                    className={serviceIcons[service.categoryName] || "bi bi-briefcase"}
                  ></i>
                </div>
                <Link
                  to={`/our-services?category=${service.categoryId}`}
                  className="stretched-link"
                >
                  <h3>{service.categoryName}</h3>
                </Link>
                {service.remark && <p>{service.remark}</p>}

                {renderChildren(service.children)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeServices;
